module.exports = __webpack_public_path__ + "static/media/exhibition-hall.f0d554bc.jpg";